import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import './styles.css';
import { getBaseUrl } from '../../../utils/url';
import Icon from '../../Icon';

export default function Link({ linkText, linkUrl, external }) {
  return linkText ? (
    <React.Fragment>
      {external ? (
        <a
          className="basic-pod-link-item"
          href={linkUrl}
          target="_blank"
          rel={(linkUrl || '').startsWith('http') ? 'noopener noreferrer' : 'opener'}
        >
          {linkText + ' '}
          <Icon name="external" />
        </a>
      ) : (
        <RouterLink
          className="basic-pod-link-item"
          to={`${getBaseUrl(window.location.pathname)}${linkUrl}`}
        >
          {linkText}
        </RouterLink>
      )}
    </React.Fragment>
  ) : null;
}

Link.propTypes = {
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  external: PropTypes.bool,
};
